import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=2e1c05fc&"
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1c05fc')) {
      api.createRecord('2e1c05fc', component.options)
    } else {
      api.reload('2e1c05fc', component.options)
    }
    module.hot.accept("./DownloadButton.vue?vue&type=template&id=2e1c05fc&", function () {
      api.rerender('2e1c05fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Buttons/DownloadButton.vue"
export default component.exports